<template>
  <div ref="navWrap" class="tabs">
    <div
      v-if="activeIndex >= 0"
      ref="tabLine"
      class="tab-line"
      :style="barStyle"
    ></div>
    <div
      v-for="(item, tabIndex) in tabList"
      :key="item.label"
      class="tab-item"
      :style="{
        color: tabIndex === activeIndex ? activeColor : normalColor,
        fontSize: fontSize,
        fontWeight: tabIndex === activeIndex ? 'bold' : 400
      }"
      @click="handleTabChange(tabIndex)"
    >
      <slot name="content" :tab="item" :tab-index="tabIndex">
        {{ item.label }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabSwitch',

  model: {
    prop: 'index',
    event: 'change'
  },

  props: {
    index: {
      type: [Number, String],
      required: true
    },

    tabList: {
      type: Array,
      required: true
    },

    activeColor: {
      type: String,
      default: '#1890ff'
    },

    fontSize: {
      type: String,
      default: '14px'
    },

    normalColor: {
      type: String,
      default: '#333'
    },

    // 每项的margin-right
    marginRight: {
      type: Number,
      default: 40
    }
  },

  data() {
    return {
      // activeIndex: 0,
      barWidth: 40,
      barOffset: 0
    }
  },

  computed: {
    barStyle() {
      return {
        width: `${this.barWidth}px`,
        transform: `translateX(${this.barOffset}px)`,
        transition: 'transform .3s',
        background: this.activeColor
      }
    },

    activeIndex: {
      get() {
        return this.index
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },

  watch: {
    activeIndex() {
      this.updateBar()
    }
  },

  mounted() {
    this.updateBar()
  },

  methods: {
    handleTabChange(index) {
      this.activeIndex = index

      this.$emit('changeTab', index)
    },

    updateBar() {
      this.$nextTick(() => {
        // 当前选中的activeKey下标
        const index = this.tabList.findIndex(
          (tab, index) => index === this.activeIndex
        )
        // 获取navWrap元素下的所有tab的元素
        const elemTabs = this.$refs.navWrap.querySelectorAll('.tab-item')
        // 获取当前选中的元素
        const elemTab = elemTabs[index]
        const barWidth = elemTab ? elemTab.offsetWidth : 0
        // 计算需要移动的距离，当index>0时进行累加
        if (index > 0) {
          let offset = 0
          for (let i = 0; i < index; i++) {
            // 此处的48为每项的margin-right
            offset += elemTabs[i].offsetWidth + (this.marginRight || 40)
          }
          // 此处的40为固定的指示条长度
          this.barOffset = offset + (barWidth - 40) / 2
        } else {
          this.barOffset = (barWidth - 40) / 2
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  align-items: center;
  position: relative;

  .tab-item {
    //min-width: 80px;
    font-size: 16px;
    color: #fff;
    padding: 8px 0;
    text-align: center;
    cursor: pointer;
    position: relative;

    &:not(:last-child) {
      margin-right: 40px;
    }
  }

  .tab-line {
    width: 40px;
    position: absolute;
    height: 2px;
    bottom: 0px;
    left: 0px;
  }
}
</style>
